import { defineTheme } from '../contracts.js';
export const blackYellow = defineTheme({
    id: 'black-yellow',
    displayName: 'Black & Yellow',
    lifecycle: 'ready',
    selectable: true,
    implementation: 'legacy',
    extensionThemeId: 'mutedffs',
    capabilities: {
        alerts: 'available',
        welcomes: 'available',
        wam: 'available',
        startup: 'external',
        achievements: 'unsupported',
        viewerSounds: 'unsupported',
        privateChatSounds: 'unsupported',
    },
});
//# sourceMappingURL=registration.js.map